import React, { useState } from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList } from "react-window";
import { AppContext } from "../AppContext.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  InvoiceRegisterPrintRequest,
  InvoiceRegisterReportCriteria,
  RestCustomerListRequest,
  RestCustomerModuleInitRequest,
  RestPageListBean,
  SalesPersonBean,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  CollapseComponent,
  ColumnDefinition,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupInvoiceModule,
} from "../modules/ModuleUtil.js";
import { ModuleUtils } from "../modules/ModuleUtils";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class InvoiceRegister extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Invoice Register Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      salesPersons: [],
      locations: [],
      customerList: new Array(),
      salesPersonBean: new SalesPersonBean(),
      summaryData: [],
      criteria: new InvoiceRegisterReportCriteria(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      isShowSalesModule: false,
      isShowInvoiceModule: false,
      moduleForPopup: [],
      isCollapsible_open: true,
      customerData: null,
      spData: null,
      customerDatas: [],
      salesPersonDatas: [],
      showAutoCompleteList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      salesPersonPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesPersonList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      showAutoCompleteLocationList: true,
      locationPageListForAutoCompleteList: new Array(),
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let salesPersons = attribute_cache.salesPersons;
    if (salesPersons != null || salesPersons != undefined) {
      salesPersons.map((attr) => {
        this.state.salesPersons.push(attr);
      });
    }
    let warehouses = attribute_cache.warehouses;
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        this.state.locations.push(attr);
      });
    }
    ModuleUtils.getInvoiceStatusList(); //
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  salesPersonCodeOnChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.showAutoCompleteSalesPersonList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
    if (isEmpty(salesPersonCode)) {
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      let criteria = this.state.criteria;
      criteria.salesPersonCode = "";
      let suggestion = [];
      let salesPersonBean = null;
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
        salesPersonBean: salesPersonBean,
      });
    } else if (showAutoCompleteList === true && salesPersonCode !== "") {
      this.readSalesPersonBySearchString(salesPersonCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  readSalesPerson = (salesPersonCode) => {
    let salesPersonBean = null;
    this.state.salesPersons.map((ln) => {
      if (ln.code === salesPersonCode) {
        salesPersonBean = ln;
      }
    });
    if (!isEmpty(salesPersonBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.salesPersonCode = salesPersonBean.code;
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ salesPersonBean: salesPersonBean });
  };
  readSalesPersonBySearchString = (searchString) => {
    let salesPersonData = this.state.salesPersons;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((sp) => {
        let salesPersonBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(salesPersonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      salesPersonPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  salesPersonEnterKeyEventHandler = (e) => {
    let salesPersonCode = e.target.value;
    this.readSalesPerson(salesPersonCode);
    this.setState({
      salesPersonPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteSalesPersonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSalesPersonList: showAutoCompleteList });
  };
  locationCodeOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let criteria = this.state.criteria;
      criteria.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        criteria: criteria,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  readLocation = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.locations.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.locationCode = locationBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean, locationData: locationData });
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.locations;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((sp) => {
        let locationBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      let suggestion = [];
      let customerData = null;
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
        customerData: customerData,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestCustomerModuleInitRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.customerCode = customerCode;
    readrestInput.isLoadChildren = true;
    readrestInput.isLockRequired = false;
    CustomerService.initCustomer(
      readrestInput,
      this.editCustomerResponse,
      this.errorCallBack
    );
  };
  readCustomerCode = (customerCode) => {
    let readrestInput = new RestCustomerModuleInitRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.customerCode = customerCode;
    readrestInput.isLoadChildren = true;
    readrestInput.isLockRequired = false;
    CustomerService.initCustomer(
      readrestInput,
      this.editCustomerCodeResponse,
      this.errorCallBack
    );
  };
  editCustomerCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.customerResponse.customer != null
    ) {
      let customerData = response.data.customerResponse.customer;
      let criteria = this.state.criteria;
      criteria.customerCode = customerData.code;
      this.setState({ customerData: customerData });
    } else {
      this.state.customerData = null;
      let customerData = this.state.customerData;
      this.setState({ customerData: customerData });
    }
  };
  editCustomerResponse = (response) => {
    if (response.data.customerResponse.customer != null) {
      let customerData = response.data.customerResponse.customer;
      let criteria = this.state.criteria;
      criteria.customerCode = customerData.code;
      this.setState({ customerData: customerData, criteria: criteria });
    }
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomer(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;

    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadInvoiceRegisterInquiryList(criteria);
  };
  loadInvoiceRegisterInquiryList = (criteria) => {
    if (SecurityAccessManager.InvoiceRegisterInquiry_IsAccessible()) {
      ReportService.inquireInvoiceRegisterReport(
        criteria,
        this.loadInvoiceRegisterPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadInvoiceRegisterPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.resultBean != null) {
      let invoiceInfoDataList = [];
      let summaryData = [];
      if (!isEmptyArray(response.data.resultBean.invoiceInfos)) {
        invoiceInfoDataList = response.data.resultBean.invoiceInfos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      if (response.data.resultBean.amountSummaryInfo != null) {
        summaryData = response.data.resultBean.amountSummaryInfo;
      }
      this.setState({
        inquiryDataList: new Array(),
      });
      setTimeout(() => {
        this.setState({
          isInquiryDatasFound: true,
          isShowResetButton: true,
          isShowClearCriteriaButton: false,
          inquiryDataList: invoiceInfoDataList,
          summaryData: summaryData,
          isCollapsible_open: false,
          isLoading: false,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        this.disable();
      }, 100);
    }
    this.setState({ isShowProgressBarPopup: false, progressLoadingText: "" });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new InvoiceRegisterReportCriteria();
    criteria.companyCode = this.companyCode;
    criteria.salesPersonCode = "";
    criteria.customerCode = "";
    criteria.invoiceFromDate = "";
    criteria.invoiceToDate = "";
    this.setState({
      criteria: criteria,
      customerDatas: [],
      salesPersonDatas: [],
      isDisableFields: false,
      salesPersonBean: null,
      customerData: null,
      isShowClearCriteriaButton: true,
    });
  };
  resetInquiry = () => {
    let criteria = new InvoiceRegisterReportCriteria();
    criteria.companyCode = this.companyCode;
    criteria.invoiceFromDate = "";
    criteria.invoiceToDate = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      salesPersonBean: null,
      customerData: null,
      customerDatas: [],
      salesPersonDatas: [],
      customerData: [],
      salesPersonData: [],
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isCollapsible_open: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new InvoiceRegisterPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.InvoiceRegisterInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateInvoiceRegisterPrintReport(
          listRequest,
          this.generateInvoicePageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.InvoiceRegisterInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateInvoiceRegisterPrintReport(
          listRequest,
          this.generateInvoicePageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateInvoicePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateInvoicePageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
          let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
             window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  addCustomer = () => {
    let criteria = this.state.criteria;
    criteria.customerCode = "";
    criteria.companyCode = this.companyCode;
    let customerData = this.state.customerData;
    let customerDatas = this.state.customerDatas;
    if (customerData != null) {
      if (!isEmptyArray(customerDatas)) {
        let exists = customerDatas.find((p) => p.code === customerData.code);
        if (!exists) {
          customerDatas.push(customerData);
          criteria.customerCodes.push(customerData.code);
          this.setState({
            criteria: criteria,
            customerDatas: customerDatas,
            customerData: null,
          });
        }
      } else {
        if (!isEmptyString(customerData.code)) {
          customerDatas.push(customerData);
          criteria.customerCodes.push(customerData.code);
          this.setState({
            criteria: criteria,
            customerDatas: customerDatas,
            customerData: null,
          });
        }
      }
    }
  };
  addSalesPerson = () => {
    let criteria = this.state.criteria;
    criteria.salesPersonCode = "";
    let salesPersonBean = this.state.salesPersonBean;
    let salesPersonDatas = this.state.salesPersonDatas;
    if (salesPersonBean != null) {
      if (!isEmptyArray(salesPersonDatas)) {
        let exists = salesPersonDatas.find(
          (p) => p.code === salesPersonBean.code
        );
        if (!exists) {
          salesPersonDatas.push(salesPersonBean);
          criteria.salesPersonCodes.push(salesPersonBean.code);
          this.setState({
            criteria: criteria,
            salesPersonDatas: salesPersonDatas,
            salesPersonBean: null,
          });
        }
      } else {
        if (!isEmptyString(salesPersonBean.code)) {
          salesPersonDatas.push(salesPersonBean);
          criteria.salesPersonCodes.push(salesPersonBean.code);
          this.setState({
            criteria: criteria,
            salesPersonDatas: salesPersonDatas,
            salesPersonBean: null,
          });
        }
      }
    }
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  deleteCustomer = (line) => {
    let criteria = this.state.criteria;
    let lineData = criteria.customerCodes;
    let customerDatas = this.state.customerDatas;
    customerDatas.map((list, index) => {
      if (list.code === line.code) {
        lineData.splice(index, 1);
        customerDatas.splice(index, 1);
      }
    });
    this.setState({ criteria: criteria, customerData: null });
  };
  deleteSalesPerson = (line) => {
    let criteria = this.state.criteria;
    let lineData = criteria.salesPersonCodes;
    let salesPersonDatas = this.state.salesPersonDatas;
    salesPersonDatas.map((list, index) => {
      if (list.code === line.code) {
        lineData.splice(index, 1);
        salesPersonDatas.splice(index, 1);
      }
    });
    this.setState({ criteria: criteria, salesPersonBean: null });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowInvoiceModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.inquiryDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({
        inquiryDataList: new Array(),
      });
      setTimeout(() => {
        this.setState({
          inquiryDataList: sorted,
        });
      }, 100);
    }
  };
  Table_Row = ({ index, style, key }) => {
    const data = this.state.inquiryDataList[index];
    return (
      <>
        {/* {index === 1 ? (
          <thead>
            <TableHeader
              {...this.state}
              handleSortingChange={this.handleSortingChange}
            />
          </thead>
        ) : null} */}

        <tr
          style={style}
          key={key}
          // style={{ width: "100%" }}
          // className={index % 2 === 0 ? "even-row" : "odd-row"}
          className="data-table_row"
        >
          <td className="wth-8 text-left">
            <Button
              size="sm"
              variant="secondry"
              className="hyperLinkText"
              onClick={(e) => this.viewInvoiceModule(e, data.invoiceNumber)}
            >
              {data.invoiceNumber}
            </Button>
          </td>
          <td className="wth-8 text-left">{data.invoiceDate}</td>
          <td className="wth-8 text-left">
            <Button
              size="sm"
              variant="secondry"
              className="hyperLinkText"
              onClick={(e) => this.viewCustomerModule(e, data.customer)}
            >
              {data.customer}
            </Button>
          </td>
          <td className="wth-16 text-left">{data.customerName}</td>
          <td className="wth-12 text-left">
            {data.customerPurchaseOrderNumber}
          </td>
          <td className="wth-8 text-left">{data.shipViaCode}</td>
          <td className="wth-8 text-left">
            {ModuleUtils.getInvoiceStatusCaption(data.invoiceStatus)}
          </td>
          <td className="wth-8 text-left">{data.salesPersons}</td>
          <td className="wth-8 text-right">
            {toCommaSeperatedAmount(data.grandTotalAmount)}
          </td>
          <td className="wth-8 text-right">
            {toCommaSeperatedAmount(data.subTotalAmount)}
          </td>
          <td className="wth-8 text-right">
            {toCommaSeperatedAmount(data.paidOtherAppliedAmount)}
          </td>
          <td className="wth-8 text-right">
            {toCommaSeperatedAmount(data.paidCreditMemoAmount)}
          </td>
          <td className="wth-8 text-right">
            {toCommaSeperatedAmount(data.invoiceDueAmount)}
          </td>
        </tr>
      </>
    );
  };

  getCaption = (status) => {
    return ModuleUtils.getInvoiceStatusCaption(status);
  };
  inquiryColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("invoice#", "invoiceNumber", true)

        .setStyleDetails("left", "", "", "wt-4", "wt-4")

        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceDate", "invoiceDate", true)

        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer#", "customer", true)

        .setStyleDetails("left", "", "", "wt-4", "wt-4")

        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustPO", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ShipVia", "shipViaCode", true)
        .setStyleDetails("left", "6", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "invoiceStatus", true, false)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setStatusDetails(true, this.getCaption)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPerson", "salesPersons", true, false)

        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("GrandTotal", "grandTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "summaryGrandTotalAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SubTotal", "subTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "summarySubTotalAmount")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("TotalPaid", "paidOtherAppliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "summaryPaidOtherAppliedAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreditPaid", "paidCreditMemoAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setSubHeaderDetails(true, "summaryPaidCreditMemoAmount")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("TotalDue", "invoiceDueAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "summaryInvoiceDueAmount")
    );

    return columns;
  };
  render() {
    const inquiryDataList = this.state.inquiryDataList;
    let isLoading = this.state.isLoading;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          showHideSecondHeader={this.showHideSecondHeader}
          onChange={this.onChange}
          customerCodeOnChange={this.customerCodeOnChange}
          salesPersonCodeOnChange={this.salesPersonCodeOnChange}
          addCustomer={this.addCustomer}
          addSalesPerson={this.addSalesPerson}
          deleteCustomer={this.deleteCustomer}
          deleteSalesPerson={this.deleteSalesPerson}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          salesPersonEnterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
          displayAutoCompleteSalesPersonList={
            this.displayAutoCompleteSalesPersonList
          }
          locationCodeOnChange={this.locationCodeOnChange}
          locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
          displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
        />
        {/* {this.state.isInquiryDatasFound && (
          <div className="div_default">
            <Table id="fabrics_tables">
              <thead>
                <tr>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "invoiceNumber")
                    }
                  >
                    InvoiceNumber
                    {this.state.order === "desc" &&
                    this.state.sortField === "invoiceNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "invoiceDate")}
                  >
                    InvoiceDate
                    {this.state.order === "desc" &&
                    this.state.sortField === "invoiceDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th onClick={(e) => this.handleSortingChange(e, "customer")}>
                    Customer
                    {this.state.order === "desc" &&
                    this.state.sortField === "customer" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "customerName")}
                  >
                    CustomerName
                    {this.state.order === "desc" &&
                    this.state.sortField === "customerName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "customerPurchaseOrderNumber")
                    }
                  >
                    CustomerPO#
                    {this.state.order === "desc" &&
                    this.state.sortField === "customerPurchaseOrderNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "shipViaCode")}
                  >
                    ShipVia
                    {this.state.order === "desc" &&
                    this.state.sortField === "shipViaCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "invoiceStatus")
                    }
                  >
                    Status
                    {this.state.order === "desc" &&
                    this.state.sortField === "invoiceStatus" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "salesPersons")}
                  >
                    SalesPersons
                    {this.state.order === "desc" &&
                    this.state.sortField === "salesPersons" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "grandTotalAmount")
                    }
                  >
                    GrandTotal <br />{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "grandTotalAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                    <div class="bg-white text-danger text-right">
                      {summaryDetail.summaryGrandTotalAmount}
                    </div>
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "subTotalAmount")
                    }
                  >
                    SubTotal <br />
                    {this.state.order === "desc" &&
                    this.state.sortField === "subTotalAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                    <div class="bg-white text-danger text-right">
                      {" "}
                      {summaryDetail.summarySubTotalAmount}
                    </div>
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "paidOtherAppliedAmount")
                    }
                  >
                    TotalPaid <br />{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "paidOtherAppliedAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                    <div class="bg-white text-danger text-right">
                      {summaryDetail.summaryPaidOtherAppliedAmount}
                    </div>
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "paidCreditMemoAmount")
                    }
                  >
                    CreditPaid <br />{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "paidCreditMemoAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                    <div class="bg-white text-danger text-right">
                      {summaryDetail.summaryPaidCreditMemoAmount}
                    </div>
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "invoiceDueAmount")
                    }
                  >
                    TotalDue <br />{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "invoiceDueAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                    <div class="bg-white text-danger text-right">
                      {summaryDetail.summaryInvoiceDueAmount}
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
                {inquiryDataList.map((inquiryInfo, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.viewInvoiceModule(e, inquiryInfo.invoiceNumber)
                        }
                      >
                        {inquiryInfo.invoiceNumber}
                      </Button>
                    </td>
                    <td>{inquiryInfo.invoiceDate}</td>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.viewCustomerModule(e, inquiryInfo.customer)
                        }
                      >
                        {inquiryInfo.customer}
                      </Button>
                    </td>
                    <td>{inquiryInfo.customerName}</td>
                    <td>{inquiryInfo.customerPurchaseOrderNumber}</td>
                    <td>{inquiryInfo.shipViaCode}</td>
                    <td>
                      {ModuleUtils.getInvoiceStatusCaption(
                        inquiryInfo.invoiceStatus
                      )}
                    </td>
                    <td>{inquiryInfo.salesPersons}</td>
                    <td className="text-right">
                      {inquiryInfo.grandTotalAmount}
                    </td>
                    <td className="text-right">{inquiryInfo.subTotalAmount}</td>
                    <td className="text-right">
                      {inquiryInfo.paidOtherAppliedAmount}
                    </td>
                    <td className="text-right">
                      {inquiryInfo.paidCreditMemoAmount}
                    </td>
                    <td className="text-right">
                      {inquiryInfo.invoiceDueAmount}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {inquiryDataList.length != 0 ? null : (
              <div className="no_Data">{"NO DATA"}</div>
            )}
          </div>
          
        )} */}
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              enableVritualizer={true}
              subHeaderData={this.state.summaryData}
              label={"Inquiry Data List"}
            />
          </div>
          // <div style={{ width: "100%", height: "80vh" }}>
          //   <AutoSizer
          //   // style={{ width: "100%" }}
          //   >
          //     {({ height, width }) => (
          //       <div
          //       // style={{ width: "100%" }}
          //       >
          //         <Table
          //           className="data-table"
          //           // style={{ width: "100%" }}
          //           //id="fabrics_tables"
          //         >
          //           <thead>
          //             <TableHeader
          //               {...this.state}
          //               handleSortingChange={this.handleSortingChange}
          //             />
          //           </thead>
          //         </Table>
          //         <div
          //           style={{ height: height - 40 }}
          //           // id="fabrics_tables"
          //           className="data-table"
          //         >
          //           <FixedSizeList
          //             height={height - 40}
          //             width={1856}
          //             itemSize={50} // Height of each row
          //             itemCount={inquiryDataList.length}
          //           >
          //             {this.Table_Row}
          //           </FixedSizeList>
          //         </div>
          //       </div>
          //     )}
          //   </AutoSizer>
          // </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      criteria: this.props.criteria,
      customerList: this.props.customerList,
      isCollapsible_open: this.props.isCollapsible_open,
    };
    this.customerCodeRef = React.createRef();
    this.salesPersonCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.customerCodeRef.current != null) {
      this.customerCodeRef.current.focus();
    }
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });

    let salesPersonLookupHandler = new GenericAttributeLookupHandler(
      this.props.salesPersons,
      "SalesPerson"
    );
    this.setState({ salesPersonLookupHandler: salesPersonLookupHandler });
    let locationLookupHandler = new GenericAttributeLookupHandler(
      this.props.locations,
      "Location"
    );
    this.setState({ locationLookupHandler: locationLookupHandler });
  };
  deleteCustomer = (e, val, rowData) => {
    this.props.deleteCustomer(rowData);
  };
  deleteSalesPerson = (e, val, rowData) => {
    this.props.deleteSalesPerson(rowData);
  };
  salesPersonColumnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition().setDetails("SalesPerson", "code", true)
    );
    columns.push(
      new ColumnDefinition().setDetails("Name", "description", true)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Remove", <DeleteIcon />, false)
        .setClickDetails(false, true, this.deleteSalesPerson, <DeleteIcon />)
    );

    return columns;
  };
  customerColumnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition().setDetails("CustomerCode", "code", true)
    );
    columns.push(
      new ColumnDefinition().setDetails("Name", "description", true)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Remove", <DeleteIcon />, false)
        .setClickDetails(false, true, this.deleteCustomer, <DeleteIcon />)
    );

    return columns;
  };

  addCustomer = (e) => {
    if (e.detail === 1) {
      this.props.addCustomer();
      if (this.customerCodeRef != null) {
        this.customerCodeRef.current.clear();
        this.customerCodeRef.current.focus();
      }
    }
  };
  addSalesPerson = (e) => {
    if (e.detail === 1) {
      this.props.addSalesPerson();
      if (this.customerCodeRef != null) {
        this.salesPersonCodeRef.current.clear();
        this.salesPersonCodeRef.current.focus();
      }
    }
  };
  customerCodeOnChange = (e) => {
    this.props.customerCodeOnChange(e);
  };
  salesPersonCodeOnChange = (e) => {
    this.props.salesPersonCodeOnChange(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) this.props.showHideSecondHeader();
  };
  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };
  displayAutoCompleteList = () => {
    this.props.displayAutoCompleteList();
  };
  salesPersonEnterKeyEventHandler = (e) => {
    this.props.salesPersonEnterKeyEventHandler(e);
  };
  displayAutoCompleteSalesPersonList = () => {
    this.props.displayAutoCompleteSalesPersonList();
  };
  locationEnterKeyEventHandler = (e) => {
    this.props.locationEnterKeyEventHandler(e);
  };
  displayAutoCompleteLocationList = () => {
    this.props.displayAutoCompleteLocationList();
  };
  locationCodeOnChange = (e) => {
    this.props.locationCodeOnChange(e);
  };
  render() {
    let criteria = this.props.criteria;
    let isDisableFields = this.props.isDisableFields;
    let customerDatas = this.props.customerDatas;
    let salesPersonDatas = this.props.salesPersonDatas;
    return (
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.customerCodeRef}
              name="customerCode"
              onChange={this.customerCodeOnChange}
              value={criteria.customerCode}
              lookupRequired={true}
              lookupHandler={this.state.customerLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
              autoCompleteListData={
                this.props.customerPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteList}
              showAutoCompleteList={this.props.showAutoCompleteCustomerList}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            <Button
              className="header_buttons enterFocus"
              size="sm"
              disabled={isDisableFields}
              onClick={(e) => this.addCustomer(e)}
            >
              Add
            </Button>
          </Col>
          <Col sm="1">
            <FormLabel>SalesPerson</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.salesPersonCodeRef}
              name="salesPersonCode"
              onChange={this.salesPersonCodeOnChange}
              value={criteria.salesPersonCode}
              lookupRequired={true}
              lookupHandler={this.state.salesPersonLookupHandler}
              enterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
              autoCompleteListData={
                this.props.salesPersonPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteSalesPersonList}
              showAutoCompleteList={this.props.showAutoCompleteSalesPersonList}
              disabled={isDisableFields}
            />
          </Col>
          <Col>
            <Button
              className="header_buttons enterFocus"
              size="sm"
              disabled={isDisableFields}
              onClick={(e) => this.addSalesPerson(e)}
            >
              Add
            </Button>
          </Col>
          <Col sm="4">
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>From</FormLabel>
              </Col>
              <Col sm="4">
                <DatePickerComponent_adv
                  name="invoiceFromDate"
                  onChange={this.onChange}
                  value={criteria.invoiceFromDate}
                  disabled={isDisableFields}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>To</FormLabel>
              </Col>
              <Col sm="4">
                <DatePickerComponent_adv
                  name="invoiceToDate"
                  onChange={this.onChange}
                  value={criteria.invoiceToDate}
                  disabled={isDisableFields}
                />
              </Col>
              <Col sm="1">
                <CollapseComponent
                  isOpen={this.props.isCollapsible_open}
                  onClick={(e) => this.showHideSecondHeader(e)}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        {this.props.isCollapsible_open && (
          <Row className="align-top">
            <Col sm="4">
              <CustomTable
                data={customerDatas}
                columns={this.customerColumnDefinitions()}
                label={"Customer Data List"}
              />
            </Col>
            <Col sm="4">
              <CustomTable
                data={salesPersonDatas}
                columns={this.salesPersonColumnDefinitions()}
                label={"SalesPerson Data List"}
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
const TableHeader = (props) => {
  const [order, setOrder] = useState(props.order);
  const [sortField, setSortField] = useState(props.sortField);
  const handleSortingChange = (e, accessor) => {
    props.handleSortingChange(e, accessor);
  };
  const summaryDetail = props.summaryData;
  return (
    <tr>
      <th
        onClick={(e) => handleSortingChange(e, "invoiceNumber")}
        className="wth-8"
      >
        InvoiceNumber
        {order === "desc" && sortField === "invoiceNumber" ? (
          <span className="drp-dwn-cntr">
            <DropDwnUp />
          </span>
        ) : (
          <span className="drp-dwn-cntr">
            <DropDwnDown />
          </span>
        )}
      </th>
      <th
        onClick={(e) => handleSortingChange(e, "invoiceDate")}
        className="wth-8"
      >
        InvoiceDate
        {order === "desc" && sortField === "invoiceDate" ? (
          <span className="drp-dwn-cntr">
            <DropDwnUp />
          </span>
        ) : (
          <span className="drp-dwn-cntr">
            <DropDwnDown />
          </span>
        )}
      </th>
      <th onClick={(e) => handleSortingChange(e, "customer")} className="wth-8">
        Customer
        {order === "desc" && sortField === "customer" ? (
          <span className="drp-dwn-cntr">
            <DropDwnUp />
          </span>
        ) : (
          <span className="drp-dwn-cntr">
            <DropDwnDown />
          </span>
        )}
      </th>
      <th
        onClick={(e) => handleSortingChange(e, "customerName")}
        className="wth-16"
      >
        CustomerName
        {order === "desc" && sortField === "customerName" ? (
          <span className="drp-dwn-cntr">
            <DropDwnUp />
          </span>
        ) : (
          <span className="drp-dwn-cntr">
            <DropDwnDown />
          </span>
        )}
      </th>
      <th
        onClick={(e) => handleSortingChange(e, "customerPurchaseOrderNumber")}
        className="wth-12"
      >
        CustomerPO#
        {order === "desc" && sortField === "customerPurchaseOrderNumber" ? (
          <span className="drp-dwn-cntr">
            <DropDwnUp />
          </span>
        ) : (
          <span className="drp-dwn-cntr">
            <DropDwnDown />
          </span>
        )}
      </th>
      <th
        onClick={(e) => handleSortingChange(e, "shipViaCode")}
        className="wth-8"
      >
        ShipVia
        {order === "desc" && sortField === "shipViaCode" ? (
          <span className="drp-dwn-cntr">
            <DropDwnUp />
          </span>
        ) : (
          <span className="drp-dwn-cntr">
            <DropDwnDown />
          </span>
        )}
      </th>
      <th
        onClick={(e) => handleSortingChange(e, "invoiceStatus")}
        className="wth-8"
      >
        Status
        {order === "desc" && sortField === "invoiceStatus" ? (
          <span className="drp-dwn-cntr">
            <DropDwnUp />
          </span>
        ) : (
          <span className="drp-dwn-cntr">
            <DropDwnDown />
          </span>
        )}
      </th>
      <th
        onClick={(e) => handleSortingChange(e, "salesPersons")}
        className="wth-8"
      >
        SalesPersons
        {order === "desc" && sortField === "salesPersons" ? (
          <span className="drp-dwn-cntr">
            <DropDwnUp />
          </span>
        ) : (
          <span className="drp-dwn-cntr">
            <DropDwnDown />
          </span>
        )}
      </th>
      <th
        onClick={(e) => handleSortingChange(e, "grandTotalAmount")}
        className="wth-8"
      >
        GrandTotal <br />{" "}
        {order === "desc" && sortField === "grandTotalAmount" ? (
          <span className="drp-dwn-cntr">
            <DropDwnUp />
          </span>
        ) : (
          <span className="drp-dwn-cntr">
            <DropDwnDown />
          </span>
        )}
        <div className="bg-white text-danger text-right">
          {toCommaSeperatedAmount(summaryDetail.summaryGrandTotalAmount)}
        </div>
      </th>
      <th
        onClick={(e) => handleSortingChange(e, "subTotalAmount")}
        className="wth-8"
      >
        SubTotal <br />
        {order === "desc" && sortField === "subTotalAmount" ? (
          <span className="drp-dwn-cntr">
            <DropDwnUp />
          </span>
        ) : (
          <span className="drp-dwn-cntr">
            <DropDwnDown />
          </span>
        )}
        <div className="bg-white text-danger text-right">
          {" "}
          {toCommaSeperatedAmount(summaryDetail.summarySubTotalAmount)}
        </div>
      </th>
      <th
        onClick={(e) => handleSortingChange(e, "paidOtherAppliedAmount")}
        className="wth-8"
      >
        TotalPaid <br />{" "}
        {order === "desc" && sortField === "paidOtherAppliedAmount" ? (
          <span className="drp-dwn-cntr">
            <DropDwnUp />
          </span>
        ) : (
          <span className="drp-dwn-cntr">
            <DropDwnDown />
          </span>
        )}
        <div className="bg-white text-danger text-right">
          {toCommaSeperatedAmount(summaryDetail.summaryPaidOtherAppliedAmount)}
        </div>
      </th>
      <th
        onClick={(e) => handleSortingChange(e, "paidCreditMemoAmount")}
        className="wth-8"
      >
        CreditPaid <br />{" "}
        {order === "desc" && sortField === "paidCreditMemoAmount" ? (
          <span className="drp-dwn-cntr">
            <DropDwnUp />
          </span>
        ) : (
          <span className="drp-dwn-cntr">
            <DropDwnDown />
          </span>
        )}
        <div className="bg-white text-danger text-right">
          {toCommaSeperatedAmount(summaryDetail.summaryPaidCreditMemoAmount)}
        </div>
      </th>
      <th
        onClick={(e) => handleSortingChange(e, "invoiceDueAmount")}
        className="wth-8"
      >
        TotalDue <br />{" "}
        {order === "desc" && sortField === "invoiceDueAmount" ? (
          <span className="drp-dwn-cntr">
            <DropDwnUp />
          </span>
        ) : (
          <span className="drp-dwn-cntr">
            <DropDwnDown />
          </span>
        )}
        <div className="bg-white text-danger text-right">
          {toCommaSeperatedAmount(summaryDetail.summaryInvoiceDueAmount)}
        </div>
      </th>
    </tr>
  );
};
function InvoiceRegisterInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <InvoiceRegister {...props} name="" /> <br />
    </div>
  );
}

export default InvoiceRegisterInquiry;
